<template>
  <v-container class="section pt-16" id="contact">
    <!-- The section heading -->
    <div
      class="font-weight-bold bluegray--text pt-8 text-h4 text-center"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      Talk To Us
    </div>

    <!-- The subtitle -->
    <div
      class="section__subtitle text-center mt-4"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      Any question or remarks? Just write us a message!
    </div>

    <!-- The container for the form -->
    <v-row class="mt-16 d-flex justify-center">
      <v-col cols="12" lg="10">
        <!-- The form -->
        <div
          class="form pa-5"
          v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
        >
          <v-row>
            <!-- The inputs -->
            <v-col cols="12" md="6">
              <v-form
                :disabled="isLoading"
              >
                <v-text-field
                  v-model.trim="form.name"
                  class="mb-3"
                  type="text"
                  :error-messages="$v.form.name.$anyError ? ['Please enter a valid name'] : null"
                  counter="200"
                  label="Name"
                  outlined
                  required
                  dense
                  @input="$v.form.name.$touch()"
                  @blur="$v.form.name.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model.trim="form.designation"
                  class="mb-3"
                  type="text"
                  :error-messages="$v.form.designation.$anyError ? ['Please enter your designation'] : null"
                  counter="200"
                  label="Designation"
                  outlined
                  required
                  dense
                  @input="$v.form.designation.$touch()"
                  @blur="$v.form.designation.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model.trim="form.company_name"
                  class="mb-3"
                  type="text"
                  :error-messages="$v.form.company_name.$anyError ? ['Please enter a valid company name'] : null"
                  counter="200"
                  label="Company Name"
                  outlined
                  required
                  dense
                  @input="$v.form.company_name.$touch()"
                  @blur="$v.form.company_name.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model.trim="form.email"
                  class="mb-3"
                  type="email"
                  :error-messages="$v.form.email.$anyError ? ['Please enter valid email address'] : null"
                  counter="200"
                  label="Email Address"
                  outlined
                  required
                  dense
                  @input="$v.form.email.$touch()"
                  @blur="$v.form.email.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model.trim="form.spend_amount"
                  class="mb-3"
                  type="number"
                  :error-messages="$v.form.spend_amount.$anyError ? ['Please enter a valid amount'] : null"
                  label="Approx. Influencer Marketing Spend/Year ($)"
                  outlined
                  required
                  dense
                  @input="$v.form.spend_amount.$touch()"
                  @blur="$v.form.spend_amount.$touch()"
                ></v-text-field>

                <!-- <v-textarea
                  v-model.trim="form.message"
                  :error-messages="$v.form.message.$anyError ? ['Please enter valid message'] : null"
                  counter="1000"
                  label="Message"
                  outlined
                  required
                  dense
                  @input="$v.form.message.$touch()"
                  @blur="$v.form.message.$touch()"
                ></v-textarea> -->
              </v-form>

              <!-- The submit button -->
              <v-btn
                large
                block
                depressed
                class="mt-4"
                color="primary"
              >
                Send Message
              </v-btn>
            </v-col>

            <!-- Empty space -->
            <v-col md="1" class="d-none d-md-block"></v-col>

            <!-- The graphic -->
            <v-col cols="12" md="5">
              <!-- The box -->
              <div
                class="box bluegray"
                v-prlx="{ limit: { min: -20, max: 20 } }"
              >
                <!-- The image would be here -->
                <img
                  v-prlx="{ reverse: true, limit: { min: -20, max: 20 } }"
                  src="/img/svg/girl-with-laptop.svg"
                />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Import validation functions
import { email, required, minLength, maxLength } from "vuelidate/lib/validators"

// Define generator function
const generateForm = () => ({
  name: "",
  email: "",
  designation: "",
  company_name: "",
  spend_amount: ""
  // message: ""
})

// Export the SFC
export default {
  // Name of the component
  name: "TalkToUs",

  data: () => ({
    isLoading: false,

    form: generateForm()
  }),

  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(200)
      },
      email: {
        email,
        required,
        maxLength: maxLength(200)
      },
      designation: {
        required,
        maxLength: maxLength(200)
      },
      company_name: {
        required,
        maxLength: maxLength(200)
      },
      spend_amount: {
        required
      }
      // message: {
      //   required,
      //   minLength: minLength(2),
      //   maxLength: maxLength(1000)
      // }
    }
  },

  methods: {
    async handleSubmit() {
      await this.$v.$touch()

      if (this.$v.$anyError) {
        this.$store.dispatch("toasts/add", { text: "Please enter correct values" })

        return
      }

      // Show a loader while the request is being processed
      this.isLoading = true

      const loaderId = Symbol()
      await this.$store.dispatch("loaders/add", loaderId)

      try {
        await axios({
          url: "/api/contacts",
          method: "POST",
          data: this.form
        })

        this.form = generateForm()

        this.$store.dispatch("toasts/add", { text: "Message received. Thank you!" })
      } catch (error) {
        logger({ type: "Contact Form Error", error })

        // show the error message to the user
        this.$store.dispatch("toasts/add", { text: "An Error Occurred." })
      } finally {
        // remove the loader
        await this.$store.dispatch("loaders/remove", loaderId)

        // enable the button
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.section
  .form
    background #F0F0F0
    border-radius 4px

  .box
    height 100%
    min-height 400px
    border-radius 4px
    position relative

    img
      position absolute
      bottom 0
      right -44px

      @media screen and (min-width: 1200px)
        height 500px
        right -52px
</style>
